import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {Subscription} from 'rxjs';
import {PreviewTableComponent} from '../preview-table/preview-table.component';
import {MainPageComponent} from '../../../../../main/components/main/main-page.component';
import {WebServiceCreateComponent} from '../web-service-create/web-service-create.component';
import {ManagementDataBaseComponent} from '../management-data-base/management-data-base.component';
import {PreviewExcelComponent} from '../preview-excel/preview-excel.component';
import {PreviewDataSourceInfo} from '../../../../../data-source/models/preview-data-source-info.model';
import {IDataSourcePreview} from '../../interfaces/i-data-source-preview';

@Component({
  selector: 'morva-create-data-source',
  templateUrl: './create-data-source.component.html',
  styleUrls: ['./create-data-source.component.scss'],
})
export class CreateDataSourceComponent implements OnInit,OnDestroy {

  workspaceId: string;
  inputValue = '';
  loading: boolean;
  uploadType = 'DataSourceFiles';
  subscriptionIsDone: Subscription[] = [];
  previewDataSourceInfo: PreviewDataSourceInfo;

  constructor(
    private dialogService: NbDialogService,
    private dialogRef: NbDialogRef<MainPageComponent>,
    @Inject('DataSourcePreview')private dataSourcePreviewFacade: IDataSourcePreview,
  ) { }

  ngOnInit() {
    this.dataSourcePreviewFacade.updateWorkspaceId(this.workspaceId);
    this.dataSourcePreviewFacade.setAddToDashboard(false,undefined);
    this.setSubscribers();
  }

  setSubscribers(): void {
    this.subscriptionIsDone.push(this.dataSourcePreviewFacade.getPreviewDataSourceInfo$().
    subscribe(previewDataSourceInfo => {
      this.previewDataSourceInfo = previewDataSourceInfo;
    }));
    this.subscriptionIsDone.push(this.dataSourcePreviewFacade.getSubmitState$().subscribe(
      submit => {
        if(submit === 'submitted') {
          const closeOnBackdropClick = false;
          this.loading = false;
          if(this.previewDataSourceInfo.isMultiSheet) {
            this.dialogService.
            open(PreviewExcelComponent,
              {context: {workspaceId: this.workspaceId,  type: 'CreateDataSource'},
                closeOnBackdropClick});
          } else {
            this.dialogService.
            open(PreviewTableComponent,
              {context: {workspaceId: this.workspaceId,  type: 'CreateDataSource'},
                closeOnBackdropClick});
          }
          this.dataSourcePreviewFacade.setSubmitState('notSubmitted');
          this.close();
        } else if (submit === 'notSubmitted') {
          this.loading = false;
        }
      },
    ));
  }

  onFileDrop(droppedFile: File[]): void {
    this.loading = true;
    this.dataSourcePreviewFacade.uploadFile(droppedFile[0], this.workspaceId, this.uploadType);
  }

  uploadFileFromURL(url: string): void {
    this.loading = true;
    this.dataSourcePreviewFacade.uploadFileFromURL(url, this.workspaceId);
  }

  openWebServiceDialog(): void {
    const closeOnBackdropClick = false;
    this.dialogService.open(WebServiceCreateComponent, { context: { },closeOnBackdropClick });
    this.close();
  }

  openDataBaseCreateDialog(type: 'CreateSqlServer' | 'CreateOracle'): void {
    const closeOnBackdropClick = false;
    this.dialogService.open(ManagementDataBaseComponent, { context: {
        type,
        workspaceId: this.workspaceId,
      },closeOnBackdropClick })
        .onClose.subscribe(() => this.dataSourcePreviewFacade.resetConnectionTables());
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscriptionIsDone.forEach(sub => sub.unsubscribe());
  }
}
